import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeleteStoreRequest as SchemaDeleteStoreRequest } from '../schemas/DeleteStoreRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags StoreActions
 */
export const DeleteStoreContentType = 'application/json' as const;
export type DeleteStoreRequest = SchemaDeleteStoreRequest;
export type DeleteStoreResponses = LinkCommonErrorResponses & {};
export type DeleteStoreResponseSuccess = undefined;
export type DeleteStoreSearchParams = undefined;
export type DeleteStorePathParameters = undefined;
export const DeleteStoreUrl = '/store/delete' as const;
export const DeleteStoreMethod = 'POST' as const;
export const getDeleteStoreUrl = (_params?: DeleteStorePathParameters) => DeleteStoreUrl;
